import React from "react";
import { DEAL_TYPES } from "./constants";
import { createEmptyParty, FONDO_DEFAULT_OWNER } from "@/utils/afsol";

const WizardStepType = ({ dealType, setDealType, setForm }) => (
  <div className="space-y-3" data-testid="wizard-step-type">
    <p className="text-sm text-slate-500">Hvers konar viðskipti?</p>
    <div className="grid grid-cols-3 gap-3">
      {DEAL_TYPES.map((t) => (
        <button
          key={t.value}
          onClick={() => {
            setDealType(t.value);
            setForm((prev) => {
              if (t.value === "kaupa") {
                return {
                  ...prev,
                  buyer: { ...prev.buyer, owner: { ...FONDO_DEFAULT_OWNER } },
                  seller: { ...prev.seller, owner: prev.seller.owner?.kennitala === "5212161310" ? createEmptyParty("eigandi") : prev.seller.owner },
                };
              } else {
                return {
                  ...prev,
                  seller: { ...prev.seller, owner: { ...FONDO_DEFAULT_OWNER } },
                  buyer: { ...prev.buyer, owner: prev.buyer.owner?.kennitala === "5212161310" ? createEmptyParty("eigandi") : prev.buyer.owner },
                };
              }
            });
          }}
          className={`p-4 rounded-lg border-2 text-center transition-all
            ${dealType === t.value ? "border-blue-600 bg-blue-50 shadow-sm" : "border-slate-200 hover:border-slate-300 bg-white"}`}
          data-testid={`deal-type-${t.value}`}
        >
          <div className={`text-sm font-semibold ${dealType === t.value ? "text-blue-700" : "text-slate-700"}`}>{t.label}</div>
          <div className="text-[10px] text-slate-500 mt-1">{t.desc}</div>
        </button>
      ))}
    </div>
  </div>
);

export default WizardStepType;
